<div class="record-payment-container" mat-dialog-content>
    <h2 *ngIf="refund">Record Refund</h2>
    <h2 *ngIf="!refund">Record Payment</h2>

    <mat-form-field class="date-picker" appearance="outline">
        <input matInput [matDatepicker]="picker" [formControl]="date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

    <ap-money mat-input class="payment-amount-input" matInput [(amount)]="amount" [negativeOnly]="refund"></ap-money>
</div>

<div mat-dialog-actions>
    <button (click)="submit('EBay')" mat-raised-button>EBay</button>
    <button (click)="submit('Bank Transfer')" mat-raised-button>Bank Transfer</button>
    <button (click)="submit('Cash')" mat-raised-button>Cash</button>
    <button (click)="submit('Card Reader')" mat-raised-button>Square</button>
    <button (click)="submit('Retainer Balance')" mat-raised-button>Account</button>
</div>
